import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 992px)";

const useIsMobile = () => {
    const getMatch = () => (typeof window !== "undefined" ? window.matchMedia(MOBILE_QUERY).matches : false);
    const [isMobile, setIsMobile] = useState(getMatch);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const mq = window.matchMedia(MOBILE_QUERY);
        const handler = (e) => setIsMobile(e.matches);
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);

    return isMobile;
};

export default useIsMobile;